import { Box } from "@mui/material";
import EntityReferenceLink from "./entityReferenceLink.component";

type EquipmentReference = {
  id?: string | number | null;
  full_name?: string | null;
  name?: string | null;
};

type EquipmentReferenceListProps = {
  equipments?: EquipmentReference[];
  canPreview?: boolean;
  fallback?: string;
  direction?: "column" | "row";
};

export default function EquipmentReferenceList({
  equipments = [],
  canPreview = true,
  fallback = "-",
  direction = "column",
}: EquipmentReferenceListProps) {
  if (equipments.length === 0) {
    return <Box component="span">{fallback}</Box>;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: direction,
        flexWrap: direction === "row" ? "wrap" : "nowrap",
        gap: direction === "row" ? 1 : 0.25,
        alignItems: direction === "row" ? "center" : "flex-start",
        minWidth: 0,
      }}
    >
      {equipments.map((equipment) => (
        <EntityReferenceLink
          key={String(equipment.id ?? equipment.full_name ?? equipment.name)}
          entityType="equipment"
          entityId={equipment.id}
          label={equipment.full_name || equipment.name || fallback}
          canPreview={canPreview && Boolean(equipment.id)}
        />
      ))}
    </Box>
  );
}
